<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import AlertError from "@/components/alert_error";
import { VueContentLoading } from "vue-content-loading";
import QrCodeCard from "@/components/qr_code_card";

export default {
  page: {
    title: "أستمارة حجز اسم منظمة",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, AlertError, VueContentLoading, QrCodeCard },
  data() {
    return {
      title: "تفاصيل الاستمارة",
      items: [
        {
          text: "الرئيسيه",
          href: "/",
        },
        {
          text: "أستمارة حجز اسم منظمة",
          href: "/workTeam",
        },
        {
          text: "التفاصيل",
          active: true,
        },
      ],

      //Page errors.
      errors: [],

      id: this.$route.params.id,
      loadingContent: true,
      president: null,
      qrCodeContent: null,
      showAlert: false,
    };
  },
  computed: {
    ...mapGetters("workTeam", ["getPresident"]),
  },
  methods: {
    ...mapActions("workTeam", ["get"]),
    handleError(error) {
      alert(error);
      this.showAlert = true;
      if (error.response.status == 422)
        this.errors = Object.values(error.response.data.errors);
      else
        this.errors = [
          `Error Code : ${error.response.status}  Message : ${error.response.data.message}`,
        ];
    },
    fetch() {
      this.get(this.id)
        .then(() => {
          this.president = this.getPresident;
          this.loadingContent = false;

          this.qrCodeContent = JSON.stringify({
            Id: this.president.qr_id,
            fullName: this.president.full_name,
            date: this.president.created_at,
          });
        })
        .catch((error) => {
          this.handleError(error);
          this.loadingContent = false;
        });
    },
    getOrgType() {
      return this.president.organization.organization_type.id == "21";
    },
  },
  created() {
    this.fetch();
  },
  mounted() {
    // setTimeout(() => {
    //   this.loadingContent = false;
    // }, 1000);
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-md-12">
        <AlertError :showDismissibleAlert="showAlert" :errors="errors"></AlertError>

        <div class="card">
          <div v-if="!loadingContent" class="card-body">
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات رئيس المنظمة</h5></div>
            <div class="row about-list">
              <h4>{{ president.full_name }}</h4>
              <div class="col-md-4">
                <div class="media">
                  <label>اللقب :</label>
                  <p>{{ president.family_name }}</p>
                </div>
                <div class="media">
                  <label>رقم الهاتف :</label>
                  <p>{{ president.phone }}</p>
                </div>
                <div class="media">
                  <label>المحافظة :</label>
                  <p>{{ president.city?.title }}</p>
                </div>
                <div class="media">
                  <label>القضاء :</label>
                  <p>{{ president.district }}</p>
                </div>
                <div class="media">
                  <label>حساب الفيسبوك لرئيس المنظمة :</label>
                  <p>{{ president.facebook }}</p>
                </div>
                <div class="media">
                  <label>حساب الانستغرام لرئيس المنظمة :</label>
                  <p>{{ president.instagram }}</p>
                </div>
              </div>
            </div>
            <hr class="hr-title" />
            <div class="break-title"><h5 class="mb-2">معلومات المنظمة او الفريق</h5></div>
            <div class="row about-list">

              <div class="col-md-12">
                <div class="media">
                  <label>الأسم الاول (الرئيسي ) للمنظمة او الفريق :</label>
                  <p>{{ president.organization.name1 }}</p>
                </div>
                <div class="media">
                  <label>الاسم الثاني ( الاحتياط 1 ) للمنظمة او الفريق :</label>
                  <p>{{ president.organization.name2 }}</p>
                </div>
                <div class="media">
                  <label>الأسم الثالث ( الاحتياط 2 ) للمنظمة او الفريق : </label>
                  <p>{{ president.organization.name3 }}</p>
                </div>
                </div>
                <!--  -->
                <div class="col-md-12">
                <div class="media">
                  <label>الأسم الاول (الرئيسي ) باللغة الانجليزية:</label>
                  <p>{{ president.organization.name1_en }}</p>
                </div>
                <div class="media">
                  <label>الاسم الثاني ( الاحتياط 1 ) باللغة الانجليزية:</label>
                  <p>{{ president.organization.name2_en }}</p>
                </div>
                <div class="media">
                  <label>الأسم الثالث ( الاحتياط 2 ) باللغة الانجليزية: </label>
                  <p>{{ president.organization.name3_en }}</p>
                </div>
                </div>
                <!--  -->

                <div class="col-md-12">
                <div class="media" >
                  <label>نوع المنظمة :</label>
                  <p v-if="getOrgType()">{{ president.organization.another_organization }}</p>
                  <p v-else>{{ president.organization.organization_type.title }}</p>
                </div>
                <div class="media">
                  <label> حساب الفيسبوك للمنظمة / الفريق :</label>
                  <p>{{ president.organization.facebook }}</p>
                </div>
                <div class="media">
                  <label>حساب الانستغرام للمنظمة / الفريق :</label>
                  <p>{{ president.organization.instagram }}</p>
                </div>
                <div class="media">
                  <label>البريد الالكتروني الرسمي للمنظمة / الفريق :</label>
                  <p>{{ president.organization.email }}</p>
                </div>
                <div class="media">
                  <label>الهاتف المخصص للتواصل مع المنظمة / الفريق :</label>
                  <p>{{ president.organization.phone }}</p>
                </div>
                
              </div>
            </div>
            <hr class="hr-title" />
            <QrCodeCard
              title="استمارة حجز اسم منظمة او فريق"
              :fullName="this.president.full_name"
              :date="this.president.created_at"
              :Id="this.president.qr_id"
              :qrCodeContent="this.qrCodeContent"
            ></QrCodeCard>

            <div class="mt-3">
              <hr />
              <b-button class="" type="button" to="/workTeam" variant="secondary"
                >رجوع</b-button
              >
            </div>
          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="110">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />

              <rect x="10" y="25" rx="1" ry="1" width="50" height="5" />
              <rect x="340" y="25" rx="1" ry="1" width="50" height="5" />

              <rect x="10" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="40" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="40" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="49" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="54" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="54" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="63" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="68" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="68" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="77" rx="1" ry="1" width="380" height="1" />

              <rect x="10" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="66" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="122" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="178" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="234" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="290" y="82" rx="2" ry="2" width="45" height="5" />
              <rect x="346" y="82" rx="2" ry="2" width="44" height="5" />
              <rect x="10" y="91" rx="1" ry="1" width="380" height="1" />
              <circle cx="340" cy="100" r="1" />
              <circle cx="350" cy="100" r="1" />
              <circle cx="363" cy="100" r="4" />
              <circle cx="376" cy="100" r="1" />
              <circle cx="386" cy="100" r="1" />
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
